import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import ReversingLabSpectraConfigListing from './ReversingLabSpectraConfigListing'
import ReversingLabSpectraCredentialsForm from './ReversingLabSpectraCredentialsForm'

export default function ReversingLabSpectraPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={ReversingLabSpectraCredentialsForm}
            PullConfigListingView={ReversingLabSpectraConfigListing}
        />
    )
}